<!--
 * @Author: DY
 * @Date: 2025-02-17 16:49:33
 * @LastEditTime: 2025-02-21 17:08:11
 * @Description: 超期解锁确认表单【技术质量管理-超期解锁】
 * @FilePath: \ShiMo_Mobile\src\views\technicalQualityManagement\overdueUnlockingConfirm\form.vue
-->
<template>
    <v-touch @swiperight="closeAllocationForm" class="wrapper">
        <div class="overdueUnlockingConfirmForm commonFormStyles">
            <HeaderNav header-title="超期解锁确认" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: closeAllocationForm }"></HeaderNav>
            <van-tabs class="currencyTabsStyle" v-model="tabActive">
                <van-tab title="基本信息" name="1">
                    <div class="formList">
                        <ul class="formItem">
                            <li class="formItemTitle">
                                <h5>申请信息表</h5>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="超期解锁申请编号"
                                    placeholder="自动生成"
                                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                    v-model="formData.BatchNumber"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="申请人"
                                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                    v-model="formData.ApplyUserName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="申请部门"
                                    :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                    v-model="formData.ApplyDeptName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="仓库编码"
                                    placeholder="请选择仓库"
                                    :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    v-model="formData.StockCode"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="仓库名称"
                                    placeholder="请选择仓库"
                                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                    v-model="formData.StockName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="库位编码"
                                    placeholder="请选择库位"
                                    :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    v-model="formData.GridCode"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="库位名称"
                                    placeholder="请选择库位"
                                    :left-icon="require('@/assets/images/icons/icon_44@2x.png')"
                                    v-model="formData.GridName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="物料代码"
                                    placeholder="请选择物料"
                                    :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                                    v-model="formData.MaterialCode"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="物料短描述"
                                    placeholder="请选择物料"
                                    :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                    v-model="formData.MaterialShortName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="申请解锁产品卡数量"
                                    placeholder="请输入数量"
                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                    v-model="formData.ApplyCount"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="申请说明"
                                    placeholder="请输入申请说明"
                                    :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                    type="textarea"
                                    v-model="formData.ApplyRemark"
                                    :rows="3"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="审核人"
                                    :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    v-model="formData.CheckName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="审核部门"
                                    :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                    v-model="formData.CheckDeptName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="解锁产品卡数量"
                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                    v-model="formData.CheckCount"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    :disabled="isDisabled"
                                    label="解锁说明"
                                    :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                    type="textarea"
                                    v-model="formData.CheckRemark"
                                    :rows="3"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="制单时间"
                                    :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                    v-model="formData.CreationTime"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="状态"
                                    :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                    v-model="Status"
                                ></van-field>
                            </li>
                        </ul>
                    </div>
                </van-tab>
                <van-tab title="产品明细" name="2">
                    <div class="formList">
                        <ul class="formItem">
                            <li class="formItemTitle">
                                <h5>产品明细表</h5>
                                <van-icon name="add" v-if="!isDisabled" @click="selectCards"></van-icon>
                            </li>
                            <dl class="materialList" v-for="(item, index) in formData.Cards" :key="`material_${index}`">
                                <dt>
                                    <van-icon name="clear" v-if="!isDisabled" @click="deleteMaterial(index)"></van-icon>
                                    <h5>生产批号</h5>
                                    <p>{{ item.ProductCardNumber }}</p>
                                </dt>
                                <dd>
                                    <div>
                                        <p>物料代码：</p>
                                        <input type="text" disabled v-model="item.MaterialCode">
                                    </div>
                                    <div>
                                        <p>短描述：</p>
                                        <input type="text" disabled v-model="item.MaterialShortName">
                                    </div>
                                    <div>
                                        <p>单包重量：</p>
                                        <input type="text" disabled v-model="item.PackageSingleWeight">
                                    </div>
                                    <div>
                                        <p>生产天数：</p>
                                        <input type="text" disabled v-model="item.ProductDay">
                                    </div>
                                </dd>
                            </dl>
                        </ul>
                    </div>
                </van-tab>
            </van-tabs>
            <footer class="currencyFooterStyle btns">
                <template v-if="!isDisabled">
                    <van-button type="primary" loading-type="spinner" @click="returnForm">
                        退回
                    </van-button>
                    <van-button type="primary" loading-type="spinner" @click="submitForm">
                        确认
                    </van-button>
                    <van-button type="primary" loading-type="spinner" @click="saveForm">
                        保存
                    </van-button>
                </template>
                <van-button v-else type="primary" loading-type="spinner" @click="closeAllocationForm">
                    关闭
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    name: 'overdue-unlocking-confirm-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/overdueUnlockingConfirm') {
            this.$store.commit('noKeepAlive', 'overdue-unlocking-confirm-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isRefresh: false,
            tabActive: 0,
            isDisabled: false,
            Status: '',
            formData: {
                Id: '',
                BatchNumber: '',
                ApplyUserId: '',
                ApplyUserName: '',
                ApplyDeptId: '',
                ApplyDeptName: '',
                ApplyCount: 0,
                ApplyRemark: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                GridId: '',
                GridCode: '',
                GridName: '',
                MaterialCode: '',
                MaterialName: '',
                MaterialShortName: '',
                CheckId: '',
                CheckName: '',
                CheckTime: '',
                CheckDeptId: '',
                CheckDeptName: '',
                CheckCount: 0,
                CheckRemark: '',
                Status: 0,
                AutoIndex: 0,
                YearIndex: '',
                CreationTime: '',
                Cards: [],
            },
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.Cards) {
            (this.$route.params.Cards || []).forEach(item => {
                this.formData.Cards.push({
                    ProductCardId: item.id,
                    ProductCardNumber: item.product_card_number,
                    ProductDate: item.product_date,
                    PackageSingleWeight: item.package_single_weight,
                    MaterialCode: item.material_code,
                    MaterialName: item.material_name,
                    MaterialShortName: item.material_short_name,
                    ProductDay: item.product_day,
                });
            });
            this.loadCheckCount();
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'overdueUnlockingConfirm',
                params: {
                    isRefresh: this.isRefresh,
                },
            });
        },
        async initpage() {
            this.formData = await this.getformDataRequrst(this.$route.params.id);

            this.formData.CheckName = this.$takeTokenParameters('Name');
            this.formData.CheckId = this.$takeTokenParameters('Uid');
            this.formData.CheckDeptName = this.$takeTokenParameters('DeptName');
            this.formData.CheckDeptId = this.$takeTokenParameters('DeptId');
            if (this.$route.params.type === 'view') {
                this.isDisabled = true;
            }
            this.Status = this.loadStatus(this.formData.Status);
        },
        loadStatus(nub) {
            const staus = ['未提交', '已提交', '已退回', '已确认'];
            return staus[nub];
        },
        selectCards() {
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择产品卡',
                    sourcePath: 'overdueUnlockingConfirmForm',
                    requestUrl: `/basicplatform/tabledata?material_code=${this.formData.MaterialCode}&grid_id=${this.formData.GridId}`,
                    listCode: 'overdue_select_product_card',
                    callbackDataKey: 'Cards',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    type: 'checkbox',
                    pageSize: 100,
                    showTotal: true,
                    totalKey: 'package_single_weight',
                    headerList: [{
                        name: '产品卡号',
                        code: 'product_card_number',
                        isTitle: true,
                    }, {
                        name: '物料代码',
                        code: 'material_code',
                        icon: 'icon_46@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '生产部门',
                        code: 'product_workshop_name',
                        icon: 'icon_45@2x',
                    }, {
                        name: '生产日期',
                        code: 'product_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '单包重量（吨）',
                        code: 'package_single_weight',
                        icon: 'icon_16@2x',
                    }, {
                        name: '生产天数',
                        code: 'product_day',
                        icon: 'icon_36@2x',
                    }],
                },
            });
        },

        deleteMaterial(index) {
            this.formData.Cards.splice(index, 1);
            this.loadCheckCount();
        },

        loadCheckCount() {
            this.formData.CheckCount = this.formData.Cards.reduce((total, item) => {
                return total + (item.PackageSingleWeight ? parseFloat(item.PackageSingleWeight) : 0);
            }, 0);
        },

        async saveForm() {
            const res = await this.saveformDataRequrst(this.formData);
            if (res) {
                this.isRefresh = true;
                this.$toast.success('保存成功。');
            }
        },
        async returnForm() {
            const res = await this.returnFormRequrst(this.formData.Id);
            if (res) {
                this.$toast.success('退回成功。');
                this.isRefresh = true;
                this.closeAllocationForm();
            }
        },
        async submitForm() {
            const res = await this.submitFormRequrst(this.formData.Id);
            if (res) {
                this.$toast.success('提交成功。');
                this.isRefresh = true;
                this.closeAllocationForm();
            }
        },
        getformDataRequrst(id) {
            return this.$axios.$get(`/interfaceApi/sale/product_card_overdue/info/${id}`);
        },
        saveformDataRequrst(requestData) {
            return this.$axios.$post('interfaceApi/sale/product_card_overdue/save', requestData);
        },
        submitFormRequrst(id) {
            return this.$axios.$post(`/interfaceApi/sale/product_card_overdue/confirm/${id}`);
        },
        returnFormRequrst(id) {
            return this.$axios.$post(`/interfaceApi/sale/product_card_overdue/back/${id}`);
        },
    },
};
</script>
<style lang="stylus">
.overdueUnlockingConfirmForm
    background: #f0f0f0;
    .currencyTabsStyle
        height 0
        flex 1
    .formList
        padding 10rpx
        &.formList_Readonly
            height calc(100% - 44rpx)
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                h5
                    font-size 16rpx
                    color #e93743
                p
                    margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.7)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.7)
</style>
